// src/pages/MyPage/components/CancelUserConfirmPopup.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Popup from "../../../../assets/components/PopupGroup";

const CancelUserConfirmPopup = ({ open, onConfirm, onCancel }) => {
  const navigate = useNavigate();
  
  const handleCancel = () => {
    navigate("/ads/main", { state: { tab: "mypage" } });
  }

  return (
    <Popup
      isOpen={open}
      onClose={onCancel}
      title="회원 탈퇴"
      subtitle={
        `회원 탈퇴 시 계정 정보 및 보유 중인 토큰이 삭제되어 복구할 수 없습니다.

        정말로 탈퇴하시겠어요?`
      }
      buttonVariant="columm"
      buttonProps={{
        topText: "탈퇴",
        bottomText: "계속 사용",
        onTop: onConfirm,
        onBottom: handleCancel,
        topType: "alert",
        bottomType: "border",
      }}
    />
  );
};

export default CancelUserConfirmPopup;
